import React from "react";
import {
	ModalLabel,
	ModalTitle,
	Modal,
	AmountWrapper,
	ExpiredText,
	OkWrapper,
	Icon
} from "./CongratsModal.style";
import { useTranslation } from "react-i18next";
import { getFormattedNumber } from "@utils";
import moment from "moment";

const CongratsModal = ({ data, handleOk }) => {
	const { t } = useTranslation();

	return (
		<>
			<Modal
				open={data.open}
				closable={false}
				footer={null}
				style={{
					textAlign: "center",
				}}
				centered={true}
				// onCancel={handleOk}
				width={340}
				height={325}
			>
				<Icon />

				<ModalTitle>{t("spin.spinWinningTitle")}</ModalTitle>

				<ModalLabel>{t("spin.spinWinningDescription")}</ModalLabel>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: 'center'
					}}
				>
					<AmountWrapper>{`${getFormattedNumber(
						data.winningAmount ?? 0
					)}`}</AmountWrapper>
				</div>

				<OkWrapper
					onClick={handleOk}
					type="default"
				>{t("common.ok")}</OkWrapper>
				
				<ExpiredText
					style={{
						visibility: data.expired_on ? "visible" : "hidden",
					}}
				>
					{t("spin.expiredMessage")}
					{` ${moment.unix(data.expired_on).format("DD MMM YYYY, hh:mm:ss A")}`}
				</ExpiredText>

			</Modal>
		</>
	);
};

export default CongratsModal;
